module.exports = __webpack_public_path__ + "static/SouthKorea_dark-4fc2c62200054ad90e8184d6109ee560.svg";